import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
export var FlexibleWorkTimeMonitoringActions;
(function (FlexibleWorkTimeMonitoringActions) {
    FlexibleWorkTimeMonitoringActions["GET_FLEXIBLE_WORK_TIME_MONITORING_REQUEST"] = "GET_FLEXIBLE_WORK_TIME_MONITORING_REQUEST";
    FlexibleWorkTimeMonitoringActions["GET_FLEXIBLE_WORK_TIME_MONITORING_SUCCESS"] = "GET_FLEXIBLE_WORK_TIME_MONITORING_SUCCESS";
    FlexibleWorkTimeMonitoringActions["GET_FLEXIBLE_WORK_TIME_MONITORING_FAIL"] = "GET_FLEXIBLE_WORK_TIME_MONITORING_FAIL";
})(FlexibleWorkTimeMonitoringActions || (FlexibleWorkTimeMonitoringActions = {}));
function getFlexibleWorkTimeMonitoringRequest() {
    return { type: FlexibleWorkTimeMonitoringActions.GET_FLEXIBLE_WORK_TIME_MONITORING_REQUEST };
}
function getFlexibleWorkTimeMonitoringSuccess(payload) {
    return { type: FlexibleWorkTimeMonitoringActions.GET_FLEXIBLE_WORK_TIME_MONITORING_SUCCESS, payload };
}
function getFlexibleWorkTimeMonitoringFail() {
    return { type: FlexibleWorkTimeMonitoringActions.GET_FLEXIBLE_WORK_TIME_MONITORING_FAIL };
}
// Endpoint added by backend #37311; not yet present in the generated client, so the request is
// composed by hand through the shared `wtsApi.request` transport (same as the new-store-slice
// template). Replace with `wtsApi.reports.<method>` once apigen covers the endpoint.
export function getFlexibleWorkTimeMonitoring(params) {
    return (dispatch) => {
        dispatch(getFlexibleWorkTimeMonitoringRequest());
        return wtsApi.request({
            path: '/Reports/FlexibleWorkTimeMonitoring',
            method: 'GET',
            query: params,
            format: 'json'
        })
            .then(({ data }) => {
            const report = data?.Data ?? null;
            dispatch(getFlexibleWorkTimeMonitoringSuccess(report));
            if (!report?.Users?.length) {
                toastr.warning(I18n.t('NoDataAvailable'), '');
            }
        })
            .catch((error) => {
            dispatch(getFlexibleWorkTimeMonitoringFail());
            toastrError(error);
        });
    };
}
